import { apiRequest } from "@/services/api/apiClient.js";
import internalApi from "@/services/api/internalApi.js";

export const fetchDashboardData = async (url) => {
    try {
        const response = await apiRequest({
            client: internalApi,
            method: "get",
            url,
            sendToken: false,
        });

        const dashboard = Array.isArray(response) ? response[0] : response;

        return dashboard;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const fetchWidgetData = async (url, params) => {
    try {
        return await apiRequest({
            client: internalApi,
            method: "get",
            url,
            params,
            sendToken: true,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};
